import PropTypes from 'prop-types';

import { propTypeBorderStyle } from './basic';

export const propTypeShape = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.number,
  borderStyle: propTypeBorderStyle,
  borderWidth: PropTypes.number,
};

const propTypeStyleTextfieldOuter = PropTypes.shape(propTypeShape);

export default propTypeStyleTextfieldOuter;
